import React from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'
import CustomLink from './CustomLink'

const ExetelAFriendBanner = (props) => {
    return (
        <div className='exetel-a-friend-banner module'>
            <div className='row'>
                <div className='col-8 col-lg-4'>
                    <h1 className='m-0 mb-2'>Exetel-a-friend and save!</h1>
                    <p className='m-0 mb-2 mb-lg-4 lh'>
                        Refer your friends to an eligible broadband service and save on your home broadband fee.
                    </p>
                    <CustomLink to='/exetel-a-friend' className='btn btn-custom'>Find out more</CustomLink>
                </div>
            </div>
        </div>
    )
}

ExetelAFriendBanner.propTypes = {}

export default ExetelAFriendBanner



// WEBPACK FOOTER //
// ./resources/js/components/ExetelAFriendBanner.js